import React, { useState } from "react"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import Collapse from "@material-ui/core/Collapse"

const useStylesMenuItem = makeStyles((theme) => ({
  root: {
    paddingLeft: (props) =>
      props.nested === "true" ? theme.spacing(5) : theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    borderRadius: 4,
    marginTop: theme.spacing(1),
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    backgroundColor: (props) =>
      props.active === "true" ? theme.palette.secondary.main : "transparent",
    opacity: (props) => (props.active === "true" ? 1 : 0.9),
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      opacity: 1,
    },
  },
  expand: {
    transform: "rotate(-180deg)",
    transition: "transform 0.5s",
  },
}))

function MenuItem({ title, active, onClick, nested, icon }) {
  const classes = useStylesMenuItem({
    active: active ? "true" : "false",
    nested: nested ? "true" : "false",
  })
  return (
    <div className={classes.root} onClick={onClick}>
      <Box mr={3}>{icon}</Box>
      <Typography variant="body2">{title}</Typography>
    </div>
  )
}

export default MenuItem

export function NestedMenuItem({
  title,
  submenu,
  onChangeRoute,
  historyRoot,
  icon,
}) {
  const classes = useStylesMenuItem()
  const [expand, setExpand] = useState(
    !!submenu.find((item) => item.path === historyRoot)
  )
  const toggle = () => {
    setExpand(!expand)
  }

  return (
    <>
      <div className={classes.root} onClick={toggle}>
        <Grid container justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Box mr={3}>{icon}</Box>
            <Typography variant="body2">{title}</Typography>
          </Box>
          <ExpandMoreIcon className={expand ? classes.expand : ""} />
        </Grid>
      </div>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        {submenu.map(({ name, path }) => (
          <MenuItem
            key={name}
            title={name}
            nested="true"
            active={path === historyRoot}
            onClick={() => onChangeRoute(path)}
          />
        ))}
      </Collapse>
    </>
  )
}
